const ko = {
  finishOrder: "완료",
  finishedOrder: "완료됨",
  unfinishedOrder: "미완료",
  code: "터미널 고객 코드",
  name1: "터미널 고객 이름 1",
  name2: "터미널 고객 이름 2",
  shortName: "터미널 고객 약어",
  country: "국적/지역",
  address: "주소",
  zipCode: "우편번호",
  email: "이메일 주소",
  contact: "담당자",
  phone: "전화",
  fax: "팩스",
  mobile: "휴대전화",
  account1: "은행 1",
  bank1: "은행 계좌 1",
  swiftCode1: "은행 코드 1",
  account2: "은행 2",
  bank2: "은행 계좌 2",
  swiftCode2: "은행 코드 2",
  currency: "통화",
  saleType: "판매 채널",
  creditLevel: "신용 수준",
  creditLine: "신용 한도",
  depositRate: "입금비율(%)",
  tradeTerm: "거래 조건",
  payMethod: "결제 방법",
  commissionRate: "수수료율",
  org: "담당부서",
  billingDays: "청구 기간(일)",
  principal: "클라이언트",
  relatedDocuments: "관련 문서(계약서/사업 허가증/청구서류)",
  documents: "관련 정보",
  affiliates: "제휴사",
  customerList: "터미널 고객 목록",
  addCustomer: "터미널 고객 추가",
  price: "가격",
  shipAddress: "배송 주소",
  shipAddressBook: "배송 주소록",
  addShipAddress: "배송 주소 추가",
  shipAddressName: "수취인 이름",
  plShipAddressName: "수취인 이름을 입력하세요",
  shipAddressType: "수취인 유형",
  defaultAddress: "기본 주소",
  setDefault: "기본 주소로 설정",
  remark: "비고",
  bySearchShipAddress: "수취인 이름, 주소 또는 전화번호로 검색",
  plPrice: "가격을 입력해주세요",
  priceMax: "최대값은 {{ num }}입니다",
  priceMin: "최소값: ​​{{ num }}",
  plProductPrice:
    "제품을 선택해주세요. 재고명과 재고코드를 입력하시면 검색이 가능합니다",
  plCustomer: "최종 고객을 선택해주세요",
  addPrice: "제품 가격 추가",
  customerRequired: "터미널 고객 정보는 비워둘 수 없습니다",
  productRequired: "제품 정보는 비워둘 수 없습니다",
  priceRequired: "가격은 비어 있을 수 없습니다",
  product: "제품",
  priceDetail: "가격 정보",
  exitsPrice: "이 제품 가격은 이미 존재합니다",
  productInfo: "제품 정보",
  orderNumber: "판매 주문 번호",
  internalNumber: "내부 주문 번호",
  receivingUnit: "수신 유닛",
  approvalStatus: "승인 상태",
  customerContact: "최종 고객 연락처",
  receivingContact: "연락처 수신",
  customerContactPhone: "최종 고객 연락처 전화번호",
  receivingContactMobile: "수신 연락처 휴대전화",
  orderType: "판매 유형",
  plOrderType: "판매 유형을 선택해주세요",
  taxRate: "세율(%)",
  quantity: "수량",
  materialStatus: "자재 상태",
  productionStatus: "생산 상태",
  shipmentStatus: "배송 상태",
  receivingStatus: "터미널 고객 수신 상태",
  paymentStatus: "결제 상태",
  receivingAddress: "수신 주소",
  realPrice: "실제 가격",
  totalPrice: "총 가격",
  revisePrice: "가격 조정",
  actualPrice: "실제 가격",
  orderState: "주문 상태",
  passed: "통과",
  notApproval: "승인 대기 중",
  plInnerNumber: "내부 주문 번호를 입력하세요",
  plReceivingUnit: "수신 단위를 입력해 주세요",
  plReceivingContact: "수신 연락처를 입력해 주세요",
  plReceivingContactMobile: "배송담당자 휴대폰번호를 입력해주세요",
  plReceivingAddress: "배송지 주소를 입력해주세요",
  orderProduct: "주문 품목",
  plMfgr: "회사 모델을 입력하세요",
  plCustomerModel: "터미널 고객 모델을 입력하세요",
  plProductName: "제품 이름을 입력하세요",
  plReqDeliDate: "배송날짜를 선택해주세요",
  plSmtStartDate: "예상 출시 날짜를 선택하십시오",
  plPreFinishDate: "완공 예정일을 선택하십시오",
  plUrgencyLevel: "긴급도 수준을 입력하세요",
  plSpecialReq: "특별 요구사항을 입력하세요",
  plReRemark: "귀하의 의견을 입력해 주세요",
  plQuantity: "수량을 입력해주세요",
  customerShortName: "터미널 고객 약어",
  productCode: "재고 코드",
  productName: "제품 이름",
  productModel: "제품 모델",
  productUom: "주 계량 단위",
  addOrder: "주문 추가",
  orderSearchTip:
    "주문 번호, 최종 고객 약어, 재고 코드, 최종 고객 모델, 회사 모델, 재고 이름, 제품 모델, 최종 고객 코드, 최종 고객 이름 1, 최종 고객 이름 2로 검색",
  innerNumber: "내부 주문 번호",
  customerModel: "터미널 고객 모델",
  mfgr: "회사 모델",
  reRemark: "비고",
  reqDeliDate: "배달요청시간",
  smtStartDate: "예상 온라인 날짜",
  preFinishDate: "완공 예정일",
  urgencyLevel: "긴급도",
  specialReq: "특별 요구 사항",
  orderInfo: "주문 정보",
  customerInfo: "터미널 고객 정보",
  proInfo: "제품 정보",
  reportInfo: "보고서 데이터",
  saleTotalQuantity: "생산해야 하는 총 수량",
  outPro: "배송",
  inStock: "재고 있음",
  dataReportSearch: "주문번호, 최종고객정보, 재고정보 키워드로 검색",
  notReportData: "아직 보고서 데이터가 없습니다",
  reportSearchTip:
    "주문 번호, 최종 고객 코드, 최종 고객 약어, 재고 코드, 재고 이름으로 검색",
  addEdit: "생산 데이터 추가/편집",
  productionSearchTip:
    "주문번호, 재고코드, 재고명, 터미널 고객정보 키워드로 검색",
  exitsData: "해당 날짜의 데이터가 이미 존재합니다",
  time: "시간",
  updateSuccess: "수정 성공",
  history: "역사적 세부 사항",
  plCode: "터미널 고객 코드를 입력하세요",
  plName1: "터미널 고객 이름 1을 입력하세요",
  plName2: "터미널 고객 이름 2를 입력하세요",
  plShortName: "터미널 고객의 약어를 입력하세요",
  plAddress: "터미널 고객 주소를 입력하세요",
  plZipCode: "터미널 고객의 우편번호를 입력하세요",
  plEmail: "최종 고객의 이메일 주소를 입력하세요",
  plContact: "연락처를 입력해주세요",
  plPhone: "단말기 고객 전화번호를 입력해 주세요",
  plFax: "단말기 고객 팩스번호를 입력해주세요",
  plMobile: "단말기 고객님의 휴대폰 번호를 입력해 주세요",
  plBank1: "은행계좌번호 1을 입력하세요",
  plAccount1: "계좌은행 1을 입력해주세요",
  plSwiftCode1: "은행 코드 1을 입력하세요",
  plBank2: "은행계좌번호 2를 입력하세요",
  plAccount2: "계좌은행 2를 입력해 주세요",
  plSwiftCode2: "은행 코드 2를 입력하세요",
  plSaleTypes: "판매 유형을 선택해주세요",
  plCreditLevels: "신용 수준을 선택하세요",
  plCreditLine: "신용 한도를 입력하세요",
  plDepositRate: "입금비율을 입력해주세요",
  plTradeTerms: "거래 조건을 선택하세요",
  plPaymentMethod: "결제방법을 선택해주세요",
  plDictCommissionRate: "수수료율을 입력하세요",
  plAffiliates: "제휴사를 입력해주세요",
  plBillingDays: "청구일을 입력해주세요",
  plPrincipal: "원금을 입력해주세요",
  plTaxRate: "세율을 입력해주세요",
  plOrg: "조직을 선택해주세요",
  saleTypeAdd: "판매 유형 추가",
  saleTypeDetail: "판매 유형 세부 정보",
  payAdd: "결제 방법 추가",
  payDetail: "결제 방법 세부 정보",
  tradeAdd: "거래 조건 추가",
  tradeDetail: "거래 조건 세부 정보",
  codeRequired: "터미널 고객 코드 필요",
  codeExisted: "터미널 고객 코드가 이미 존재합니다",
  prevRequired: "먼저 이전 데이터를 추가하세요",
  bySearchCustomer:
    "터미널 고객 코드, 터미널 고객 이름 1, 터미널 고객 이름 2, 터미널 고객 약어, 주소로 검색",
  bySearch:
    "주식코드, 주식명, 최종고객코드, 최종고객명1, 최종고객명2, 최종고객약어, 주소로 검색",
  bySearchPrice: "재고 코드, 재고 이름, 제품 모델로 검색",
  infoExisted: "이 정보는 이미 존재합니다",
  customerNotExist: "단말기 고객 정보가 존재하지 않거나 삭제되었습니다",
  estimateDays: "예상 도착 일수",
  expiredAt: "만료 시간",
  plEstimateDays: "배달예정일을 입력해주세요",
  plExpiredAt: "만료일을 선택해주세요",
  shippingMethod: "배송 방법",
  plShipping: "배송방법을 선택해주세요",
  customerType: "최종 고객 유형",
  plCustomerType: "터미널 고객 유형을 선택해 주세요",
  productNotExisted: "제품을 선택해주세요",
  orderSuccessProjectError:
    "주문 정보 수정이 성공했지만, 제품 정보 수정은 실패했습니다",
  projectSuccessOrderError:
    "제품 정보 수정이 성공했지만 주문 정보 수정이 실패했습니다",
  productPre: "승인되기 전에 제품을 선택하세요",
  innerNumberPre: "승인 전에 내부 주문 번호를 입력하세요",
  passError: "승인 실패",
  passSuccess: "승인 통과",
  orderList: "주문 목록",

  taxPrice: "세금 포함 단가",
  plTaxPrice: "세금 포함 단가를 입력해주세요",

  addRequirement: "리뷰 양식 추가",
  requirement: "요구 사항 목록",

  notRequirement: "아직 요구 사항 목록이 생성되지 않았습니다",
  orderDate: "주문 날짜",
  selectColumns: "내보낼 열 선택",
  editOrder: "주문 수정",
  updateErr: "주문 정보 수정 실패",
  exportPI: "PI 템플릿 내보내기",

  aPrice: "조정 가격",
  discount: "할인/할인",
  sPrice: "총 판매 가격",
  send: "비/사은품",
  sendQuantity: "비/사은품 수량",
  sendAPrice: "비/사은품 조정 가격",
  sendDiscount: "비/사은품 할인/할인",
  sendPrice: "비/사은품 총 가격",
  orderTotal: "주문 총액",
  discountHelp:
    "최대 할인 가격은 판매 가격(예비품 제외)을 초과할 수 없습니다: {{count}}",

  // Excel导出相关
  quotationSheet: "견적서",
  to: "수신:",
  mov: "결제조건:",
  effectiveDate: "유효일:",
  modelNo: "모델 번호",
  mfgrNo: "제조사 번호",
  picture: "사진",
  descriptionOfProduct: "제품 설명",
  chipSet: "칩셋",
  package: "패키지 (개/박스)",
  unitPrice: "단가",
  note: "참고사항",
  quotationNote1: "1) 위 견적은 선적 전 100% 결제를 기준으로 합니다.",
  quotationNote2: "2) 주문 금액이 40,000 USD 미만인 경우 가격 조건은 EX-WORK이 적용됩니다.",
  quotationNote3: "3) 견적 유효기간: 오늘부터 2주.",
  quotationNote4: "4) 계약금(보증금)으로 주문 확정",
  exportFailed: "내보내기 실패:",
  quotationTitle: "견적서",
  contactPerson: "담당자:",
  officeTel: "사무실 전화:",
  emailLabel: "이메일:",
  date: "날짜:",
  quotationNumber: "견적서 번호:",
  respectedCustomer: "존경하는 고객님",
  quotationIntro: "ZIONCOM 베트남 공장에 관심을 가져주셔서 감사합니다. 귀하가 제공한 정보와 당사와 직접 협력하려는 요구를 바탕으로, 서비스 제안 및 관련 견적을 기꺼이 제공해 드립니다.",
  no: "번호",
  quotationProductCode: "품번",
  quotationProductDesc: "제품 설명",
  quotationUnit: "단위",
  quotationCurrency: "통화",
  moqPrice: "최소주문량/ 구매 가격 (세금 제외)",
  attention: "참고:",
  quotationAttention1: "1. 견적 포함: 인건비, 솔더 페이스트 및 VSIP II 빈즈언성 배송비.",
  quotationAttention2: "2. 견적 미포함: 원자재 및 부가가치세(VAT).",
  quotationAttention3: "3. 결제 조건: 월 정산 후 30일 이내에 결제해야 합니다.",
  quotationAttention4: "4. 최소 주문량(MOQ): 1,000개 미만인 경우 주문당 2,720,000 VND의 금형 비용이 부과됩니다",
  customerConfirmation: "고객 확인",
  zioncomVietnam: "Zioncom (Vietnam) Jsc",
  inquiryTemplate: "견적 서식",
  quotationTemplate: "견적서 서식",
  transferOrder: "주문 이관 정보",
  customerPriceTemplate: "고객 가격 템플릿",
  importCustomerPrice: "고객 가격 가져오기",
  swapRes: "전환 주문 결과",
  originSale: "원본 판매 주문",
  orderNo: "주문 번호",
  prodOrderNo: "생산 주문 번호",
  oldCode: "구 자재 번호",
  prodCode: "제품 코드",
  prodName: "제품명",
  prodMod: "규격/모델",
  count: "수량",
  uom: "단위",
  batch: "로트 번호",
  origin: "부서",
  productor: "자재 담당자",
  confirmer: "품질 확인",
  prodManager: "생산 관리자",
  warehouseer: "창고 관리자",
  approver: "검토자",
  checker: "승인자",
  inboundNo: "입고 주문 번호",
  inboundDate: "입고 일자",
  warehouse: "창고",
  finishedWarehouse: "완제품 창고",
  inboundType: "입고 유형",
  prodIn: "완제품 입고 주문",
  littleTotal: "소계",
  total: "합계",
  saleSwap: "판매 주문으로 전환",
  purSwap: "구매 주문으로 전환",
  notApi: "이 고객은 WmsApi가 구성되지 않아 주문 전환을 할 수 없습니다!",
  notSale: "이 판매 주문의 상품이 수요 주문 실행 조건을 충족하지 않아 전환할 수 없습니다!",
  purchaseData: "구매 데이터",
  confirmGeneratePurOrder: "구매 주문을 생성하시겠습니까?",
  notCusPros: "고객의 WMS 시스템에 이러한 자재가 존재하지 않습니다. 먼저 고객의 WMS 시스템에서 자재 데이터를 유지보수하세요.",
  notPurProPrice: "고객의 WMS 시스템에 해당 공급업체의 구매 가격 정보가 존재하지 않습니다. 먼저 고객의 WMS 시스템에서 관련 구매 가격 정보를 유지보수하세요.",
  purSucc: "구매 주문이 생성되었습니다",
  onlyOneCustomer: "동일한 고객의 판매 주문만 선택할 수 있습니다!",
  editOutPl: "출고 가능 수량이 업데이트되었습니다. 출고 수량을 수정하세요.",
  bomCopyTip: "이 판매 주문에 BOM 첨부파일이 있습니다. 새 주문에 BOM 첨부파일도 함께 복사하시겠습니까?",
  bomCopyYes: "판매 주문 및 BOM 첨부파일 복사",
  bomCopyCancel: "판매 주문만 복사",
  receiverFax: "수령인 팩스",
  receiverPhone: "수령인 전화",
  licenseId: "사업자등록증",
  licenseAddress: "사업자등록 주소",
  invoiceNumber: "발행된 청구 번호",
  invoiceAddress: "청구서 발송 주소",
  printDate: "작성일",
  printPageNo: "페이지",
  domesticSaleOrder: "국내 판매 명세서",
  printSaleNo: "판매 주문 번호",
  printCustomerName: "고객 전체 이름",
  printUnifiedTitle: "사업자등록증",
  printOrderDate: "문서 날짜",
  printSendAddress: "배송 주소",
  printPhone: "연락처",
  printInvoiceNumber: "송장 번호",
  printInvoiceAddress: "송장 주소",
  printContact: "담당자",
  printRemark: "비고",
  printSeq: "번호",
  printProductName: "품명",
  printQuantity: "판매 수량",
  printBQuantity: "증정/예비 수량",
  printUom: "단위",
  printPrice: "단가",
  printAmount: "금액",
  onlyOneSelectip: "하나의 문서를 선택하세요",
  printSale: "판매 전표 인쇄",
  printTotalQuantity: "수량 합계",
  printSaleAmount: "판매 금액(본화)",
  printSaleTax: "판매 세액(본화)",
  printTotalAmount: "합계 금액(본화)",
  orderPrintLeft: "서명 후 배송 담당자를 통해 반송 또는 팩스 회신 부탁드립니다: {{fax}}. 감사합니다!!",
  orderPrintRight: "자기 보관용(흰색) 회계용(파란색) 서명용(빨간색) 고객용(노란색)",
  printApprove: "결재",
  printWarehouse: "창고",
  printSales: "영업",
  printMaker: "작성",
  printCustomerSign: "고객 서명",
  toOfficial: "정식 주문으로 전환",
  toOfficialConfirm: "선택한 {{count}}개 주문을 정식 주문으로 전환하시겠습니까?",
  toOfficialSingleConfirm: "정식 주문으로 전환하시겠습니까?",
  toOfficialSuccess: "정식 주문 전환 성공",
  toOfficialError: "다음 주문의 정식 주문 전환에 실패했습니다",
  toOfficialHasRequirement: "다음 주문은 이미 요구 목록이 있어 정식 주문으로 전환할 수 없습니다",
};

export default ko;
